import Multilanguage, {
    MULTILANGUAGE_CHANGE_EVENT,
    MULTILANGUAGE_CLASS,
} from './Multilanguage';

export { MULTILANGUAGE_CHANGE_EVENT, MULTILANGUAGE_CLASS };
export default Multilanguage;
